import * as yup from 'yup'
import { EditionType } from '@graphics/gfx-common/dist/constants'

export const capabilityValidationSchema = yup.object({
  title: yup
    .string()
    .trim()
    .max(50, 'The text is too long, maximum number of characters is 50.')
    .required('This is a required field.'),
  description: yup
    .string()
    .trim()
    .max(255, 'The text is too long, maximum number of characters is 255.')
    .required('This is a required field.'),
  editionTypes: yup.array().required('This is a required field.'),
  publishingLocation: yup
    .string()
    .trim()
    .required('This is a required field.'),
  lifetime: yup
    .number()
    .nullable()
    .typeError('Please use numbers only.')
    .integer('Please use numbers only.')
    .min(0, 'Please use numbers only.')
    .max(
      1095,
      'Life time exceeds the allowed 3 years limit. Please enter a value under 1095.'
    ),
})

export const requiredMediaTypeGroupValidate = (
  value: string,
  editionTypes: EditionType[]
): string | undefined => {
  if (
    !value &&
    editionTypes.some(
      (item) =>
        item === EditionType.GraphicFile || item === EditionType.GraphicFolder
    )
  ) {
    return 'This is a required field'
  }
}

export const otherMediaTypeGroupValidate = (
  value: string,
  editionTypes: EditionType[]
): string | undefined => {
  if (
    !value &&
    editionTypes.some((item) => item === EditionType.GraphicFolder)
  ) {
    return 'This is a required field'
  }
}
